import axios from "axios";
import { getToken, getTokenHeader } from "../../../Token";
import { allCityUrl, allStateUrl } from "../urls";

export const GetAllStates = async () => {
  return new Promise(async (next) => {
    const token = await getToken();
    await axios
      .get(allStateUrl(), { params: {}, ...getTokenHeader(token) })
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({
          error: true,
          message: err.response?.data?.message || err.message,
        });
      });
  });
};

export const GetAllCityOfState = async (stateId) => {
  return new Promise(async (next) => {
    const token = await getToken();
    await axios
      .get(`${allCityUrl()}/${stateId}`, { params: {}, ...getTokenHeader(token) })
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({
          error: true,
          message: err.response?.data?.message || err.message,
        });
      });
  });
};